
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateAgentDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(45)]),
    street: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    zipcode: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    city: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    phoneCompany: new FormControl<string | undefined>(undefined, [Validators.maxLength(45)]),
    mailCompany: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    contactPerson: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    mailTimeReports: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
})
;
}
      